import { Component, OnInit, Input } from '@angular/core';
import * as io from 'socket.io-client';
import { environment } from '../../environments/environment';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { MiscService } from 'src/services/misc.service';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import clonedeep from "lodash.clonedeep";
import { TTDateAgoPipe, TTDateFormatPipe } from 'src/app/global.pipe';
import { GeoFenceService } from 'src/services/geofence.service';

@Component({
  selector: 'rm-live-tracking',
  templateUrl: './live-tracking.component.html',
  styleUrls: ['./live-tracking.component.css']
})
export class LiveTrackingComponent implements OnInit {

  @Input() gln: string;
  @Input() gcp: string;
  @Input() tracking: boolean = true;
  @Input() hideToolbar: boolean = false;
  @Input() record: any;
  google: any;
  gmap: any;
  markers: any[] = [];
  cMarkers: any[] = [];
  rMarkers: any[] = [];
  positionArr: any[] = [];
  listener: boolean = true;
  showAll: boolean = false;
  filteredFences: boolean = false;
  showingAllFenceData: boolean = false;
  stateCtrl = new FormControl();
  filteredStates: Observable<any[]>;
  devices: any[];
  selectedId: any;
  paths: any[] = [];
  searchTxt: string = '';
  filteredDevices: any[] = [];
  pastDevices: any[];
  packid: any;
  packageobj: any;
  searchField;
  panelOpenState: any = false;
  passingEventdata:any;

  constructor(
    private miscService: MiscService,
    private globalCfgService: GlobalCfgService,
    private ttdateago: TTDateAgoPipe,
    private ttdateformat: TTDateFormatPipe,
    private geofenceservice:GeoFenceService
  ) {}

  ngOnInit() {
    var user = this.globalCfgService.getFullUserObj();
    this.google = window["google"];
    var options = {
      center: { lat: 51.476852, lng: -0.0005 },
      zoom: 2,
      mapId: '32c64ca2d80e5193'
    };
     
    this.gmap = new this.google.maps.Map(
      document.getElementById("rm_map_div"),
      options
    );


    if (this.record) {
      if (this.tracking) {
        setTimeout (() => {
          this.eventListner(this);
        }, 1000);
        this.loadHistory(true);
      } else {
        this.loadHistory();
      }
    } else {
      this.loadActiverackingList();
      setTimeout (() => {
        this.showAllTrackers();
      }, 1000);
    }
  }

  eventListner(thisRef) {

    var socket = io(environment.socketUrl + '?apiKey=' + environment.websocketApiKey, { transport: ['websocket'] });

    socket.on('connect', function () {
      console.log("Connection to socket io established...");
    });
    socket.on('validate', function (event) {
      var eventData = event.txnEvent;

      if (eventData.instanceId !== thisRef.record.linkedItemId) {
        //ignore event, if this happens
        return;
      }

      thisRef.record.lastTrackedOnDt = eventData.eventTime;
      
      thisRef.passingEventdata = eventData;
      

      console.log("eventData", eventData);
      var position = eventData.readPoint;

      let positionVal: any = {
        lat: parseFloat(position.lat),
        lng: parseFloat(position.lng)
      };
      if (!eventData.isInvalid === false) {
        thisRef.addMarkerWithTimeout(thisRef, positionVal, 'RED', eventData);
      } else if (eventData.txnType == 'UNAVAILABLE' || eventData.medicineStatus == "UNAVAILABLE") {
        thisRef.addMarkerWithTimeout(thisRef, positionVal, 'ORANGE', eventData);
      } else {
        thisRef.addMarkerWithTimeout(thisRef, positionVal, '#2FC8C8', eventData);
      }
    });
  }

  addMarkerWithTimeout(thisref, position, color, eventData) {
    let currentTemperature = '';
    let currentMoisture = '';
    let updatedTime = '';

    if(eventData.temperature){
      currentTemperature = '<p>Temperature : <b> ' + eventData.temperature + '</b> </p>'
    } else {
      currentTemperature = '<p>Temperature : <b> NA </b> </p>'
    }

    if(eventData.humidity){
      currentMoisture = '<p>Humidity : <b> ' + eventData.humidity + '</b> </p>'
    } else {
      currentMoisture = '<p>Humidity : <b> NA </b> </p>'
    }

    if(eventData.logTime){
      updatedTime = '<p>Updated : <b> ' + this.ttdateformat.transform(eventData.logTime) + '</b> </p>'
    } else {
      updatedTime = '<p>Updated : <b> NA </b> </p>'
    }

    var contentString = '<div id="content">' +
      '<p>Medicine Name : <b> ' + eventData.name + '</b> </p>' +
      '<p>Medicine Status : <b> ' + eventData.instanceStatus + '</b> </p>' +
      '<p>Action : <b> ' + eventData.txnType + '</b> </p>' +
      '<p>User Name : <b> ' + eventData.user.name + '</b> </p>' +
      currentTemperature +
      currentMoisture +
      updatedTime +
      '</div>';

    var infowindow = new this.google.maps.InfoWindow({
      content: contentString
    });

    this.positionArr.push(position);

    if (this.record["linkedWithType"] == 'package') {
      var pkgMarker = new this.google.maps.Marker({
        position: position,
        map: this.gmap,
        animation: this.google.maps.Animation.DROP,
        icon: {
          url: './assets/images/package_marker.png',
          scaledSize: new this.google.maps.Size(40, 40),
          origin: new this.google.maps.Point(0, 0),
          anchor: new this.google.maps.Point(20, 20),
        },
        zIndex: 100
      });
      this.markers.push(pkgMarker);

      var ringMarker = new this.google.maps.Marker({
        position: position,
        icon: {
          path: this.google.maps.SymbolPath.CIRCLE,
          scale: 17,
          strokeWeight: 6,
          strokeColor: '#1B61CC',
        },
        map: this.gmap,
        zIndex: 10
      });
      this.rMarkers.push(ringMarker);
      
      ringMarker.bindTo("position", pkgMarker);
      
      pkgMarker.addListener('click', function () {
        infowindow.open(thisref.gmap, pkgMarker);
      });

    } else {
      var truckMarker = new this.google.maps.Marker({
        position: position,
        map: this.gmap,
        animation: this.google.maps.Animation.DROP,
        icon: {
          url: './assets/images/truck_marker1.png',
          scaledSize: new this.google.maps.Size(30, 30),
          origin: new this.google.maps.Point(0, 0),
          anchor: new this.google.maps.Point(15, 15),
        },
        zIndex: 100
      });
      this.markers.push(truckMarker);

      var ringMarker = new this.google.maps.Marker({
        position: position,
        icon: {
          path: this.google.maps.SymbolPath.CIRCLE,
          scale: 16,
          strokeWeight: 6,
          strokeColor: '#1B61CC',
        },
        map: this.gmap,
        zIndex: 10
      });
      this.rMarkers.push(ringMarker);
      
      ringMarker.bindTo("position", truckMarker);

      truckMarker.addListener('click', function () {
        infowindow.open(thisref.gmap, truckMarker);
      });

    };

    this.loadMap(this.markers, thisref, true);
  }

  loadMap(markers: any[], thisref?, current?) {
    var mLn = markers.length;
    if (!current) {
      this.positionArr = [];
      for (var i = 0; i < mLn; i++) {
        var markerInfo = markers[i];
        // console.log("markers info: ", markerInfo);
        let position = markerInfo.readPoint;

        let positionVal: any = {
          lat: parseFloat(position.lat),
          lng: parseFloat(position.lng)
        };

        this.positionArr.push(positionVal);

        let color;
        if (!markerInfo.isInvalid === false) {
          color = 'RED';
        } else if (markerInfo.txnType == 'UNAVAILABLE') {
          color = 'ORANGE';
        } else {
          color = '#2FC8C8';
        }

        if (i == mLn - 1) {

          if (this.record["linkedWithType"] == 'package') {
            var pkgMarker = new this.google.maps.Marker({
              position: positionVal,
              map: this.gmap,
              animation: this.google.maps.Animation.DROP,
              icon: {
                url: './assets/images/package_marker.png',
                scaledSize: new this.google.maps.Size(40, 40),
                origin: new this.google.maps.Point(0, 0),
                anchor: new this.google.maps.Point(20, 20),
              },
              zIndex: 100
            });
            this.markers.push(pkgMarker);
            this.addInfoWindow(pkgMarker, markerInfo);
  
            var ringMarker = new this.google.maps.Marker({
              position: position,
              icon: {
                path: this.google.maps.SymbolPath.CIRCLE,
                scale: 17,
                strokeWeight: 6,
                strokeColor: '#1B61CC',
              },
              map: this.gmap,
              zIndex: 10
            });
            this.rMarkers.push(ringMarker);
            
            ringMarker.bindTo("position", pkgMarker);
          }
  
          if (this.record["linkedWithType"] == 'truck') {
            var truckMarker = new this.google.maps.Marker({
              position: positionVal,
              map: this.gmap,
              animation: this.google.maps.Animation.DROP,
              icon: {
                url: './assets/images/truck_marker1.png',
                scaledSize: new this.google.maps.Size(30, 30),
                origin: new this.google.maps.Point(0, 0),
                anchor: new this.google.maps.Point(15, 15),
              },
              zIndex: 100
            });
            this.markers.push(truckMarker);
            this.addInfoWindow(truckMarker, markerInfo);
      
            var ringMarker = new this.google.maps.Marker({
              position: position,
              icon: {
                path: this.google.maps.SymbolPath.CIRCLE,
                scale: 16,
                strokeWeight: 6,
                strokeColor: '#1B61CC',
              },
              map: this.gmap,
              zIndex: 10
            });
            this.rMarkers.push(ringMarker);
            
            ringMarker.bindTo("position", truckMarker);
          }
  
        } else {
          //Creating a new marker object
          var marker = new this.google.maps.Marker({
            position: positionVal,
            map: this.gmap,
            animation: this.google.maps.Animation.DROP,
            icon: {
              path: this.google.maps.SymbolPath.CIRCLE,
              scale: 12,
              strokeWeight: 6,
              strokeColor: '#1B61CC',
            },
            zIndex: 10
          });
  
          this.addInfoWindow(marker, markerInfo);
          this.markers.push(marker);
  
          //Adding marker to google map
          marker.setMap(this.gmap);
        }
      }
    } else {
      for (var i = 0; i < mLn; i++) {
        var marker = markers[i];
        if (i+2 == mLn) {
          marker.setIcon({
            path: this.google.maps.SymbolPath.CIRCLE,
            scale: 12,
            strokeWeight: 6,
            strokeColor: '#1B61CC',
          });
        }
      }
      var rLn = this.rMarkers.length;
      if (rLn > 1) {
        this.rMarkers[rLn - 2].setMap(null)
      }
    }
    this.loadCurveMarkers(thisref)
  }

  loadCurveMarkers(thisref) {   
    var curveMarkerParams = [];
    var pLn = this.positionArr.length;

    for (var i = 0; i < pLn; i++) {
      var loc = this.positionArr[i];

      if (!(i+1 == pLn)) {
        var nextLoc = this.positionArr[i+1];
        var pos1 = loc;
        var pos2 = nextLoc;

        curveMarkerParams.push([thisref, pos1, pos2]);
      }
    }

    if (thisref.cMarkers.length > 0) {
      for (var i = 0; i < thisref.cMarkers.length; i++) {
        thisref.cMarkers[i].setMap(null);
      }
      thisref.cMarkers = [];
    }
    curveMarkerParams.forEach(element => {
      updateCurveMarker(element[0], element[1], element[2]);
    });

    if (this.listener) {
      this.google.maps.event.addListener(this.gmap, 'projection_changed', function() {
        for (var i = 0; i < thisref.cMarkers.length; i++) {
          thisref.cMarkers[i].setMap(null);
        }
        thisref.cMarkers = [];
  
        if (!thisref.showAll) {
          curveMarkerParams.forEach(element => {
            updateCurveMarker(element[0], element[1], element[2]);
          })
        }
      });
      this.google.maps.event.addListener(this.gmap, 'zoom_changed', function() {
        for (var i = 0; i < thisref.cMarkers.length; i++) {
          thisref.cMarkers[i].setMap(null);
        }
        thisref.cMarkers = [];
  
        if (!thisref.showAll) {
          curveMarkerParams.forEach(element => {
            updateCurveMarker(element[0], element[1], element[2]);
          })
        }
      });
      this.listener = false
    }

    function updateCurveMarker(thisref, pos1, pos2) {
      var position1 = new thisref.google.maps.LatLng(pos1);
      var position2 = new thisref.google.maps.LatLng(pos2); 

      var projection = thisref.gmap.getProjection();
      var p1 = projection.fromLatLngToPoint(position1); // xy
      var p2 = projection.fromLatLngToPoint(position2);
      var curvature = 0.5; // how curvy to make the arc

      // Calculate the arc.
      // To simplify the math, these points 
      // are all relative to p1:
      var e = new thisref.google.maps.Point(p2.x - p1.x, p2.y - p1.y), // endpoint (p2 relative to p1)
          m = new thisref.google.maps.Point(e.x / 2, e.y / 2), // midpoint
          o = new thisref.google.maps.Point(e.y, -e.x), // orthogonal
          c = new thisref.google.maps.Point( // curve control point
              m.x + curvature * o.x,
              m.y + curvature * o.y);

      var pathDef = 'M 0,0 ' +
        'q ' + c.x + ',' + c.y + ' ' + e.x + ',' + e.y;

      var zoom = thisref.gmap.getZoom(),
        scale = 1 / (Math.pow(2, -zoom));

      var symbol = {
        path: pathDef,
        scale: scale,
        strokeWeight: 2,
        strokeColor: '#1B61CC',
        // geodesic: true,
      };

      var curveMarker = new thisref.google.maps.Marker({
        position: pos1,
        clickable: false,
        icon: symbol,
        zIndex: 0, // behind the other markers
        map: thisref.gmap
      });

      thisref.cMarkers.push(curveMarker);
    }
  }

  loadHistory(current?): void {
    this.miscService.getHistory(this.record["id"], this.record["linkedWithType"], current).subscribe(
      (response: any) => {
        if (!current) {
          this.pastDevices = response;
        }

        if (current) {
          let data: any[] = response[0]["history"] // not getting medicine name
          var markers = data.slice(-1000);
          this.listener = true;
          this.loadMap(markers, this);
          this.passingEventdata = data;
        }
        
      },
      error => {
        console.log("error response: ", error);
      }
    );
  }

  addInfoWindow(marker, markerInfo) {
    let currentTemperature = '';
    let currentMoisture = '';
    let updatedTime = '';

    if(markerInfo.temperature){
      currentTemperature = '<p>Temperature : <b> ' + markerInfo.temperature + '</b> </p>'
    } else {
      currentTemperature = '<p>Temperature : <b> NA </b> </p>'
    }

    if(markerInfo.humidity){
      currentMoisture = '<p>Humidity : <b> ' + markerInfo.humidity + '</b> </p>'
    } else {
      currentMoisture = '<p>Humidity : <b> NA </b> </p>'
    }

    if(markerInfo.logTime){
      updatedTime = '<p>Updated : <b> ' + this.ttdateformat.transform(markerInfo.logTime) + '</b> </p>'
    } else {
      updatedTime = '<p>Updated : <b> NA </b> </p>'
    }

    let contentString = '<div id="content">' +
      '<p>Medicine Name : <b> '+ markerInfo.name +'</b> </p>' +  
      '<p>Medicine Status : <b> ' + markerInfo.instanceStatus + '</b> </p>' +
      '<p>Action : <b> ' + markerInfo.txnType + '</b> </p>' +
      '<p>User Name : <b> ' + markerInfo.user.name + '</b> </p>' +
      currentTemperature +
      currentMoisture +
      updatedTime +
      '</div>';

    //creating a new info window with markers info
    const infoWindow = new this.google.maps.InfoWindow({
      content: contentString
    });

    //Add click event to open info window on marker
    marker.addListener("click", () => {
      infoWindow.open(marker.getMap(), marker);
    });
  }

  loadActiverackingList() {
    this.miscService.getActiveTrackingList(this.gcp || this.globalCfgService.getGcp()).subscribe(
      (result: any) => {
        this.devices = result;
        this.devices.forEach(d => {
          d.showingFenceData = false;
        });
        this.filteredDevices = this.devices;

      }
    );
  }

  openTracking(device) {
    this.selectedId = device.id;
    this.record = device;
    this.filteredFences = true;
    //clear old markers, if any
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];

    //clear ring markers if any
    for (var i = 0; i < this.rMarkers.length; i++) {
      this.rMarkers[i].setMap(null);
    }
    this.rMarkers = [];

    //clear curve markers if any
    for (var i = 0; i < this.cMarkers.length; i++) {
      this.cMarkers[i].setMap(null);
    }
    this.cMarkers = [];

    this.showAll = false;
    this.loadHistory(true);
    setTimeout (() => {
      this.eventListner(this);
    }, 1000);
  }

  openPastTracking(device) {
    this.selectedId = device.id;
    this.record = clonedeep(device);
    this.record["id"] = this.record["deviceid"];

    //clear old markers, if any
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];

    //clear ring markers if any
    for (var i = 0; i < this.rMarkers.length; i++) {
      this.rMarkers[i].setMap(null);
    }
    this.rMarkers = [];

    //clear curve markers if any
    for (var i = 0; i < this.cMarkers.length; i++) {
      this.cMarkers[i].setMap(null);
    }
    this.cMarkers = [];

    let data: any[] = this.record["history"].slice(-100);
    this.listener = true;
    this.showAll = false;
    this.loadMap(data, this);
  }

  filterList() {
    var me = this;
    this.filteredDevices = this.devices.filter(function(val) {
      return (val.alternateName.toLowerCase().indexOf(me.searchTxt.toLowerCase()) > -1) ? true : false;
    });

  }

  showAllTrackers(reload?) {
    if (reload) {
      this.loadActiverackingList();
    }
    this.showAll = true;

    //clear old markers, if any
    for (var i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
    }
    this.markers = [];

    //clear ring markers if any
    for (var i = 0; i < this.rMarkers.length; i++) {
      this.rMarkers[i].setMap(null);
    }
    this.rMarkers = [];

    //clear curve markers if any
    for (var i = 0; i < this.cMarkers.length; i++) {
      this.cMarkers[i].setMap(null);
    }
    this.cMarkers = [];

    var dLn = this.filteredDevices.length;
    for (var i = 0; i < dLn; i++) {
      var markerInfo = this.filteredDevices[i];
      let position = markerInfo.readPoint;

      let positionVal: any = {
        lat: parseFloat(position.lat),
        lng: parseFloat(position.lng)
      };

      var lastUpdated = this.ttdateago.transform(markerInfo.lastTrackedOnDt);

      var contentString = '<div id="content">' +
      '<p>Current Temperature : <b> ' + markerInfo.temperature + '</b> </p>' +
      '<p>Current Moisture : <b> ' + markerInfo.humidity + '</b> </p>' +
      '<p>Updated : <b> ' + lastUpdated + '</b> </p>' +
      '</div>';

      var infowindow = new this.google.maps.InfoWindow({
        content: contentString
      });

      if (markerInfo["linkedWithType"] == 'package') {
        var pkgMarker = new this.google.maps.Marker({
          position: positionVal,
          map: this.gmap,
          animation: this.google.maps.Animation.DROP,
          icon: {
            url: './assets/images/package_marker.png',
            scaledSize: new this.google.maps.Size(40, 40),
            origin: new this.google.maps.Point(0, 0),
            anchor: new this.google.maps.Point(20, 20),
          },
          zIndex: 100
        });
        this.markers.push(pkgMarker);
        
        pkgMarker.addListener('click', function () {
          infowindow.open(this.gmap, pkgMarker);
        });

        var ringMarker = new this.google.maps.Marker({
          position: positionVal,
          icon: {
            path: this.google.maps.SymbolPath.CIRCLE,
            scale: 17,
            strokeWeight: 6,
            strokeColor: '#1B61CC',
          },
          map: this.gmap,
          zIndex: 10
        });
        this.rMarkers.push(ringMarker);
        
        ringMarker.bindTo("position", pkgMarker);
      } else {
        var truckMarker = new this.google.maps.Marker({
          position: positionVal,
          map: this.gmap,
          animation: this.google.maps.Animation.DROP,
          icon: {
            url: './assets/images/truck_marker1.png',
            scaledSize: new this.google.maps.Size(30, 30),
            origin: new this.google.maps.Point(0, 0),
            anchor: new this.google.maps.Point(15, 15),
          },
          zIndex: 100
        });
        this.markers.push(truckMarker);
        truckMarker.addListener('click', function () {
          infowindow.open(this.gmap, truckMarker);
        });

        var ringMarker = new this.google.maps.Marker({
          position: positionVal,
          icon: {
            path: this.google.maps.SymbolPath.CIRCLE,
            scale: 16,
            strokeWeight: 6,
            strokeColor: '#1B61CC',
          },
          map: this.gmap,
          zIndex: 10
        });
        this.rMarkers.push(ringMarker);
        
        ringMarker.bindTo("position", truckMarker);
      }
    }
  }
  
  // process fence type and show each fence as overlay on map 
  showGeoFenceDataOnMapReadOnly(fences, mapRef) {
    // console.log(fences);
    fences.forEach(fenceObj => {
      if (fenceObj.type === 'region') {
        let regionValue = fenceObj.value.replace("[", "");
        regionValue = regionValue.replace("]", "");
        fenceObj.regionValue = regionValue.toLowerCase();
        this.fetchAndShowRegionFence(fenceObj, mapRef);
      } else if (fenceObj.type === 'rectangle') {
        this.showRectangleFence(fenceObj, mapRef);
      } else if (fenceObj.type === 'circle') {
        this.showCircleFence(fenceObj, mapRef);
      } else if (fenceObj.type === 'polyline') {
        this.showPolyLineFence(fenceObj, mapRef);
      } else if (fenceObj.type === 'polygon') {
        this.showPolygonFence(fenceObj, mapRef);
      }
    });
  }

  fetchAndShowRegionFence(fenceObj, mapRef) {
    this.miscService.geocodeQuery(fenceObj.regionValue).subscribe((result: any) => {
      if (result.length > 0) {

        var latlonArr = this.geofenceservice.getLatLngArr(result[0]);
        let regionCoords = [];
				latlonArr.forEach((item) => {
					regionCoords = [...regionCoords, item];
					// const geometryObj = new this.google.maps.Data.Polygon([item]);

					// mapRef.data.add({
					// 	geometry: geometryObj,
					// });
				});
				const regionalFenceOverlay = new this.google.maps.Polygon({
					paths: regionCoords,
					fillColor: fenceObj.inside ? "#40ec40" : "#ff0000",
					strokeColor: fenceObj.inside ? "green" : "red",
					strokeWeight: 1
				});
				regionalFenceOverlay.setMap(mapRef);
        this.addOverlayToDeviceObj(fenceObj, regionalFenceOverlay);
      }
    });
  }  

  showRectangleFence(fenceObj, mapRef) {
    const rect = this.geofenceservice.showRectangleFence(fenceObj.value, fenceObj.inside, mapRef);
    const rectangle = new this.google.maps.Rectangle(rect);
    this.addOverlayToDeviceObj(fenceObj, rectangle);
  }

  showCircleFence(fenceObj, mapRef) {
    const circlefence = this.geofenceservice.showCircleFence(fenceObj.value, fenceObj.inside, mapRef);
    const circle = new this.google.maps.Circle(circlefence);
    this.addOverlayToDeviceObj(fenceObj, circle);
  }

  showPolyLineFence(fenceObj, mapRef) {
    const polylinefence = this.geofenceservice.showPolyLineFence(fenceObj.value, fenceObj.inside, mapRef);
    const polyLineOverlay = new this.google.maps.Polyline(polylinefence);
    polyLineOverlay.setMap(mapRef);
    this.addOverlayToDeviceObj(fenceObj, polyLineOverlay);
  }

  showPolygonFence(fenceObj, mapRef) {
    const polygonfence = this.geofenceservice.showPolygonFence(fenceObj.value, fenceObj.inside, mapRef);
    const polygonOverlay =new this.google.maps.Polygon(polygonfence);
    polygonOverlay.setMap(mapRef);
    this.addOverlayToDeviceObj(fenceObj, polygonOverlay);
  }

  addOverlayToDeviceObj(fenceObj, overlay) {
    const devIdx = this.devices.findIndex(dev => {
      return dev.batchNo === fenceObj.ctxId;
    });
    if(devIdx > -1) {
      this.devices[devIdx].batchOverlays.push(overlay);
    }
  }

  // get device related fences and show on map
  showDevicePackageFences(event, deviceObj) {
    event.stopPropagation();
    const devIdx = this.devices.findIndex(dev => {
      return dev.id === deviceObj.id;
    });
    if(devIdx > -1) {
      this.devices[devIdx].showingFenceData = true;
      this.miscService.getGeoFenceLiveTracking(this.devices[devIdx].linkedItemId).subscribe((response: any) => {
        this.devices[devIdx].batchFences = response.fences;
        this.devices[devIdx].batchNo = response.batchNo;
        this.devices[devIdx].batchOverlays = [];
        this.showGeoFenceDataOnMapReadOnly(this.devices[devIdx].batchFences, this.gmap);
      })
    }
  }

  // hide device related fences on map
  hideDevicePackageFences(event, deviceObj) {
    event.stopPropagation();
    const devIdx = this.devices.findIndex(dev => {
      return dev.id === deviceObj.id;
    });
    if(devIdx > -1){
      // map overlay refs that are removed for non regional fence types
      this.devices[devIdx].batchOverlays.forEach(o => {
        o.setMap(null);
      });
      this.devices[devIdx].showingFenceData = false;
      delete this.devices[devIdx].batchFences;
      delete this.devices[devIdx].batchNo;
      delete this.devices[devIdx].batchOverlays;
    }
  }

  showAllFences() {
    let packageIdsObj = {packageIds: []};
    this.filteredDevices.forEach(dev => {
      packageIdsObj.packageIds.push(dev.linkedItemId);
    });
    this.miscService.getShowAllGeoFenceLiveTrackingFences(
      JSON.stringify(packageIdsObj)
    ).subscribe((response: any) => {
      // loop through each linked fences response obj 
      response.forEach(linkedItem => {
        // loop through to find match for device with response
        packageIdsObj.packageIds.forEach(linkedItemId => {
          // only if packageId(linkedItemId) is same 
          if (linkedItemId === linkedItem.linkedItemId) {
            // update that device obj with its fences
            const devIdx = this.devices.findIndex(dev => {
              return dev.linkedItemId === linkedItem.linkedItemId;
            });
            if (devIdx > -1) {
              // only update data if not already exist
              if (this.devices[devIdx].showingFenceData === false) {
                this.devices[devIdx].showingFenceData = true;
                this.devices[devIdx].batchFences = linkedItem.fences;
                this.devices[devIdx].batchNo = linkedItem.batchNo;
                this.devices[devIdx].batchOverlays = [];
                this.showGeoFenceDataOnMapReadOnly(this.devices[devIdx].batchFences, this.gmap);
              }
            }
          }
        });
      });
      this.showingAllFenceData = true;
    });
  }

  hideAllFences() {
    this.filteredDevices.forEach(fildev => {
      const devIdx = this.devices.findIndex(dev => {
        return dev.id === fildev.id;
      });
      if(devIdx > -1){
        // only run process for devices that are showing fences
        if (this.devices[devIdx].showingFenceData === true) {
          // map overlay refs that are removed for non regional fence types
          this.devices[devIdx].batchOverlays.forEach(o => {
            o.setMap(null);
          });
          this.devices[devIdx].showingFenceData = false;
          delete this.devices[devIdx].batchFences;
          delete this.devices[devIdx].batchNo;
          delete this.devices[devIdx].batchOverlays;
        }
      }
    });
    // check if regional fence exist and remove that from map view
    this.gmap.data.forEach(feature => {
      this.gmap.data.remove(feature);
    });
    this.showingAllFenceData = false;
  }

  clearSearchField() {
    this.searchTxt = '';
  }

}
